/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import ls from 'localstorage-slim';



@Injectable({
  providedIn: 'root'
})
export class LocalStorageCustomService {
  enableEncrypt: boolean = false;

  constructor() {
    this.enableEncrypt = true;
  }

  setSavedState(state: any, localStorageKey: string) {
    localStorage.setItem(localStorageKey, JSON.stringify(state));
  }

  getSavedState(localStorageKey: string): any {
    try {
      return JSON.parse(localStorage.getItem(localStorageKey) || '{}');
    }
    catch (err) { return JSON.parse(''); }
  }

  getSavedStateAs<T>(localStorageKey: string): T | any {
    try {
      return JSON.parse(localStorage.getItem(localStorageKey) || '{}') as T | any;
    }
    catch (err) { return JSON.parse('') }
  }


  setSavedStateAsSecureStorage(state: any, localStorageKey: string) {
    ls.set(localStorageKey, JSON.stringify(state), { encrypt: this.enableEncrypt });
  }

  getSavedStateAsSecureStorage(localStorageKey: string): any {
    const get: any = ls.get(localStorageKey, { decrypt: this.enableEncrypt });
    try {
      return JSON.parse(get);
    }
    catch (err) { return JSON.parse('') }
  }

  getSavedStateAsSecureStorageAsT<T>(localStorageKey: string): T {
    const get: any = ls.get(localStorageKey, { decrypt: true });
    try {
      return JSON.parse(get) as T;
    }
    catch (err) { return JSON.parse('') }
  }

  clearStorageByKey(localStorageKey: string): void {
    ls.remove(localStorageKey);
  }

  clearAllStorage(): void {
    ls.clear();
  }
}
